// extracted by mini-css-extract-plugin
export default {"items":"SetupWizardContent_items__T7+lV"};